import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/aiplus-web/src/components/common/etc/errorTemplate.tsx");
